export const TEXT_PEOPLE = 'People';
export const TEXT_REVENUE = 'Revenue';
export const TEXT_DEAL_TOTAL = 'Deal Total';
export const TEXT_AVG_COST_VALUE = 'ACV';
export const TEXT_RATE = 'Rate';
export const TEXT_SPEND = 'Spend';
export const TEXT_CPP = 'CPP';
export const TEXT_LEAD_TIME = 'Lead Time';
